import { useCallback, useEffect, useState } from "react";
import { api } from "./api";

export function useProjects(kind) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const load = useCallback(async () => {
    try {
      const res = await api.get("/projects", { params: kind ? { kind } : {} });
      setItems(Array.isArray(res.data) ? res.data : []);
    } catch (e) {
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, [kind]);
  useEffect(() => { load(); }, [load]);
  return { items, loading, reload: load };
}
